import React, { useState } from 'react';
import Sidebar from '../../components/ui/Sidebar';
import QuickActionsToolbar from '../../components/ui/QuickActionsToolbar';
import NotificationCenter from '../../components/ui/NotificationCenter';
import Icon from '../../components/AppIcon';
import UserManagementPanel from './components/UserManagementPanel';
import SystemSettingsPanel from './components/SystemSettingsPanel';
import TemplateManagementPanel from './components/TemplateManagementPanel';
import AuditControlsPanel from './components/AuditControlsPanel';
import NodeLibraryManagementPanel from './components/NodeLibraryManagementPanel';
import ClientManagementPanel from './components/ClientManagementPanel';

const SystemConfigurationAndAdministration = () => {
  const [activeTab, setActiveTab] = useState('users');
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const tabs = [
    { id: 'users', label: 'User Management', icon: 'Users' },
    { id: 'clients', label: 'Client Management', icon: 'Briefcase' },
    { id: 'settings', label: 'System Settings', icon: 'Settings' },
    { id: 'templates', label: 'Template Management', icon: 'FileText' },
    { id: 'nodeLibrary', label: 'Node Library', icon: 'Layers' },
    { id: 'audit', label: 'Audit Controls', icon: 'Shield' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'users':
        return <UserManagementPanel />;
      case 'clients':
        return <ClientManagementPanel />;
      case 'settings':
        return <SystemSettingsPanel />;
      case 'templates':
        return <TemplateManagementPanel />;
      case 'nodeLibrary':
        return <NodeLibraryManagementPanel />;
      case 'audit':
        return <AuditControlsPanel />;
      default:
        return <UserManagementPanel />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Sidebar isCollapsed={isSidebarCollapsed} />
      <QuickActionsToolbar />
      <div className={`transition-all duration-250 ${isSidebarCollapsed ? 'lg:pl-20' : 'lg:pl-60'}`}>
        <header className="sticky top-0 z-40 bg-card border-b border-border">
          <div className="flex items-center justify-between px-4 md:px-6 lg:px-8 py-4 md:py-6">
            <div className="flex items-center gap-4">
              <button
                className="hidden lg:flex items-center justify-center w-10 h-10 rounded-xl bg-muted hover:bg-muted/80 transition-colors duration-250"
                onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
                aria-label="Toggle sidebar"
              >
                <Icon name={isSidebarCollapsed ? 'ChevronRight' : 'ChevronLeft'} size={20} />
              </button>
              <div>
                <h1 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground">
                  System Configuration
                </h1>
                <p className="text-sm md:text-base text-muted-foreground mt-1">
                  Manage users, settings, templates, and audit controls
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <NotificationCenter />
              <button
                className="flex items-center justify-center w-10 h-10 rounded-xl bg-muted hover:bg-muted/80 transition-colors duration-250"
                onClick={() => console.log('Help')}
                aria-label="Help"
              >
                <Icon name="HelpCircle" size={20} />
              </button>
            </div>
          </div>

          <div className="px-4 md:px-6 lg:px-8">
            <div className="flex items-center gap-2 overflow-x-auto pb-px">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  className={`flex items-center gap-2 px-4 py-3 border-b-2 transition-all duration-250 whitespace-nowrap ${
                    activeTab === tab?.id
                      ? 'border-primary text-primary font-medium' :'border-transparent text-muted-foreground hover:text-foreground hover:border-muted'
                  }`}
                  onClick={() => setActiveTab(tab?.id)}
                >
                  <Icon name={tab?.icon} size={18} />
                  <span className="text-sm md:text-base">{tab?.label}</span>
                </button>
              ))}
            </div>
          </div>
        </header>

        <main className="px-4 md:px-6 lg:px-8 py-6 md:py-8">
          {renderTabContent()}
        </main>
      </div>
    </div>
  );
};

export default SystemConfigurationAndAdministration;